import {DEFAULT_MODEL} from './constants';

export const createDefaultContent = (): any => {
  return {
    model: DEFAULT_MODEL,
  };
};
